'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var paper = require('./paper-e6cfe656.js');
var ReactDOM = _interopDefault(require('react-dom'));

var useContextMenu = function (_a) {
    var containerRef = _a.containerRef, menuRef = _a.menuRef, showEventName = _a.showEventName, hideEventName = _a.hideEventName, _b = _a.disableRightClick, disableRightClick = _b === void 0 ? false : _b, outsideClickCallback = _a.outsideClickCallback, showEventCallback = _a.showEventCallback;
    var _c = tslib_es6.__read(React.useState(0), 2), coordinateX = _c[0], setX = _c[1];
    var _d = tslib_es6.__read(React.useState(0), 2), coordinateY = _d[0], setY = _d[1];
    var _e = tslib_es6.__read(React.useState(false), 2), isVisible = _e[0], setVisible = _e[1];
    var showMenu = React.useCallback(function (event) {
        event.preventDefault();
        if (showEventCallback) {
            showEventCallback(event);
        }
        setX(event.pageX);
        setY(event.pageY);
        setVisible(true);
    }, [showEventCallback]);
    var showMenuOnCustomEvent = React.useCallback(function (event) {
        event.preventDefault();
        setVisible(true);
    }, [showEventCallback]);
    var hideMenu = React.useCallback(function () {
        if (isVisible) {
            setVisible(false);
        }
        if (outsideClickCallback) {
            outsideClickCallback();
        }
    }, [isVisible, outsideClickCallback]);
    var handleOutsideClick = React.useCallback(function (event) {
        var _a;
        if (!((_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
            hideMenu();
        }
    }, [hideMenu, menuRef]);
    React.useEffect(function () {
        if (containerRef.current && showEventName) {
            containerRef.current.addEventListener(showEventName, showMenuOnCustomEvent);
        }
        if (containerRef.current && hideEventName) {
            containerRef.current.addEventListener(hideEventName, hideMenu);
        }
        if (containerRef.current && !disableRightClick) {
            containerRef.current.addEventListener('contextmenu', showMenu);
        }
        document.body.addEventListener('click', handleOutsideClick);
        return function () {
            if (containerRef.current && showEventName) {
                containerRef.current.removeEventListener(showEventName, showMenuOnCustomEvent);
            }
            if (containerRef.current && hideEventName) {
                containerRef.current.removeEventListener(hideEventName, hideMenu);
            }
            if (containerRef.current && !disableRightClick) {
                containerRef.current.removeEventListener('contextmenu', showMenu);
            }
            document.body.removeEventListener('click', handleOutsideClick);
        };
    });
    return {
        coordinateX: coordinateX,
        coordinateY: coordinateY,
        isVisible: isVisible,
        showMenu: showMenu,
        hideMenu: hideMenu,
        showMenuOnCustomEvent: showMenuOnCustomEvent,
        handleOutsideClick: handleOutsideClick,
    };
};

var StyledPaper = styled__default(paper.Paper)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  top: ", "px;\n  left: ", "px;\n  width: auto;\n  height: auto;\n"], ["\n  position: absolute;\n  top: ", "px;\n  left: ", "px;\n  width: auto;\n  height: auto;\n"])), function (_a) {
    var top = _a.top;
    return top;
}, function (_a) {
    var left = _a.left;
    return left;
});
var ContextMenu = function (_a) {
    var containerRef = _a.containerRef, showEventName = _a.showEventName, hideEventName = _a.hideEventName, disableRightClick = _a.disableRightClick, outsideClickCallback = _a.outsideClickCallback, customCoordinates = _a.customCoordinates, component = _a.component, menuRef = _a.menuRef, dataTestId = _a.dataTestId, _b = _a.depth, depth = _b === void 0 ? 2 : _b, _c = _a.borderRadius, borderRadius = _c === void 0 ? 'sm' : _c, showEventCallback = _a.showEventCallback, rest = tslib_es6.__rest(_a, ["containerRef", "showEventName", "hideEventName", "disableRightClick", "outsideClickCallback", "customCoordinates", "component", "menuRef", "dataTestId", "depth", "borderRadius", "showEventCallback"]);
    var _d = useContextMenu({
        containerRef: containerRef,
        menuRef: menuRef,
        showEventName: showEventName,
        hideEventName: hideEventName,
        disableRightClick: disableRightClick,
        outsideClickCallback: outsideClickCallback,
        showEventCallback: showEventCallback,
    }), coordinateX = _d.coordinateX, coordinateY = _d.coordinateY, isVisible = _d.isVisible;
    var renderDrop = function () {
        var _a, _b;
        return (ReactDOM.createPortal(React__default.createElement(StyledPaper, tslib_es6.__assign({ top: (_a = customCoordinates === null || customCoordinates === void 0 ? void 0 : customCoordinates.y) !== null && _a !== void 0 ? _a : coordinateY, left: (_b = customCoordinates === null || customCoordinates === void 0 ? void 0 : customCoordinates.x) !== null && _b !== void 0 ? _b : coordinateX, "data-testid": dataTestId, depth: depth, borderRadius: borderRadius }, rest), component), document.body));
    };
    return isVisible ? renderDrop() : null;
};
var templateObject_1;

exports.ContextMenu = ContextMenu;
